import { z } from 'zod';

import { DrawId, LosId } from '../../BrandedIds';
import { zodTemporalInstant, zodTemporalPlainDate } from '../../Temporal';
import { zodBrandedString, zodBrandedUuid } from '../../utils';

export const ExportableDraw = z
  .object({
    id: zodBrandedUuid<DrawId>(),
    loanId: zodBrandedString<LosId>(),

    amount: z.number(),
    date: zodTemporalPlainDate,
    comment: z.string().optional(),
    isReversal: z.boolean().optional(),
    transactionId: zodBrandedUuid<DrawId>().optional(),
    externalId: z.string().optional(),
    createdAt: zodTemporalInstant.optional(),
  })
  .meta({ title: 'Draw' });

export type ExportableDraw = z.infer<typeof ExportableDraw>;
